import styled from '@xstyled/styled-components'
import { Button } from '../button'

export const MoteActionButtonRoot = styled(Button)({})
